import React from 'react';

import {AuthGuard, LogInState, useAuth} from "features/auth";
import Login from 'features/auth/pages/LogInScreen';
import RefreshToken from 'features/auth/pages/RefreshTokenScreen';
import {Route, Routes, Navigate} from "react-router-dom";
import UserManualPage from "features/userManual/pages/UserManualPage";
import {AppShell} from "./AppShell";
import {RedirectToLogin, RedirectToTokenRefresh} from "features/auth";
import Menu from "features/menu/pages/Menu";
import CategoriesPage from "features/validationRules/pages/Categories";
import UsersPage from "features/admin/pages/Users";
import ExcelDiffPage from "features/excelDiff/pages/ExcelDiffPage";
import CustomDiffPage from "features/excelDiff/pages/CustomDiffPage";
import HealthCheckPage from "features/healthcheck/pages/HealthCheckPage";
import PVRPage from "features/pvr/pages/PVRPage";
import LogsViewPage from "features/logs/pages/LogsViewPage";
import {PageNotFound} from "shared/components/PageNotFound/PageNotFound";

const AppRouter: React.FC = () => {
    const { isLoggedIn } = useAuth();

    return (
        <Routes>
            <Route element={<AuthGuard require="logged-in"><AppShell /></AuthGuard>}>
                <Route path="/" element={<Menu />} />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/categories/:cat_num" element={<CategoriesPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/users/:user_id" element={<UsersPage />} />
                <Route path="/excel-diff" element={<ExcelDiffPage />} />
                <Route path="/custom-diff" element={<CustomDiffPage />} />
                <Route path="/manufacturer-analysis" element={<HealthCheckPage />} />
                <Route path="/pvr" element={<PVRPage />} />
                <Route path="/logs" element={<LogsViewPage />} />
                <Route path="*" element={<PageNotFound/>} />
            </Route>

            <Route path="/refresh-token" element={<AuthGuard require="token-expired"><RefreshToken/></AuthGuard>} />
            <Route path="/login" element={<AuthGuard require="guest"><Login /></AuthGuard>} />

            <Route path="/user-guide" element={<UserManualPage />} />
            <Route path="*" element={
                isLoggedIn === LogInState.TokenExpired  ? <RedirectToTokenRefresh /> :
                isLoggedIn === LogInState.NotLoggedIn   ? <RedirectToLogin /> :
                <Navigate to="/" replace />
            } />
        </Routes>
    );
};

export default AppRouter;
